(function () {
  function initDots() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var list = gallery.querySelector('.product__media-list');
    if (!list) return;

    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
    if (!thumbs.length) return;

    var slides = Array.from(list.querySelectorAll('.product__media-item'));
    if (!slides.length) return;

    function setActive(index) {
      thumbs.forEach(function (t, i) {
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    // IntersectionObserver: fires when each slide is >= 50% visible
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var index = slides.indexOf(entry.target);
          if (index !== -1) setActive(index);
        }
      });
    }, { root: list, threshold: 0.5 });

    slides.forEach(function (slide) { observer.observe(slide); });

    // Also handle scroll as fallback
    list.addEventListener('scroll', function () {
      var isH = list.scrollWidth > list.scrollHeight;
      var pos  = isH ? list.scrollLeft : list.scrollTop;
      var size = isH ? list.clientWidth : list.clientHeight;
      if (!size) return;
      setActive(Math.round(pos / size));
    }, { passive: true });

    setActive(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDots);
  } else {
    initDots();
  }
})();
